import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { IAttributes } from 'src/app/models/IAttributes';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { IInsuranceDetails } from 'src/app/models/IInsuranceDetails';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessage } from 'src/app/models/IMedicationHistoryDTO';
import { MessageInbox } from 'src/app/models/IMessaging';
import { IPatientPortaInformation } from 'src/app/models/IPatientPortaInformation';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
@Component({
  selector: 'app-ppdemographics-request',
  templateUrl: './ppdemographics-request.component.html',
  styleUrls: ['./ppdemographics-request.component.css']
})
export class PPDemographicsRequestComponent implements OnInit {

  PatientDemographicsForm: FormGroup;
  PatientLastName: string = "";
  PatientMiddleName: string = "";
  PatientFirstName: string = "";
  Dob: string = "";
  Gender: string = "";
  SSN: string = "";
  Suffix: string = "";
  Ethnicity: string = "";
  Language: string = "";
  MaidenName: string = "";
  Locations: string = "";
  ContactAddressLine1: string = "";
  ContactAddressLine2: string = "";
  ContactZipCode: string = "";
  ContactZipCodeExt: string = "";
  ContactCity: string = "";
  ContactState: string = "";
  ContactHomePhone: string = "";
  ContactCellPhone: string = "";
  ContactWorkPhone: string = "";
  PreferredContactMethod: string = "";
  PrimaryEmail: string = "";
  SecondaryEmail: string = "";
  Notes: string = "";
  rejectedBy: string = '';
  rejectedDate: string = '';
  //---modified data 

  MPatientLastName: string = "";
  MPatientMiddleName: string = "";
  MPatientFirstName: string = "";
  MDob: string = "";
  MGender: string = "";
  MSSN: string = "";
  MRace: string = "";
  MEthnicity: string = "";
  MLanguage: string = "";
  MMaidenName: string = "";
  MLocations: string = "";
  MContactAddressLine1: string = "";
  MContactAddressLine2: string = "";
  MContactZipCode: string = "";
  MContactZipCodeExt: string = "";
  MContactCity: string = "";
  MContactState: string = "";
  MContactHomePhone: string = "";
  MContactCellPhone: string = "";
  MContactWorkPhone: string = "";
  MPreferredContactMethod: string = "";
  MPrimaryEmail: string = "";
  MSecondaryEmail: string = "";
  MNotes: string = "";
  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private messageService: MessagesService, private router: Router,
    private route: ActivatedRoute, private rxService: RxService,
    private sharedService: SharedService, public dialog: MatDialog
    , private personalService: PersonalInfoService, private _datePipe: DatePipe,
    private schedulerservice: SchedularServiceService) {

    this.personalDropDownsBinding();

  }
  public linkID: number;

  ngOnInit() {
    ;
    this.PatientDemographicsForm = this.formBuilder.group({
      rejectNotes: ['', Validators.required],
      rejectReason: [''],

    })
    this.linkID = Number(this.route.snapshot.paramMap.get('linkId'));

    this.getPeresonalInfo(this.linkID);
    this.getPatientRequestDetails(this.linkID);
  }
  lstPatientRequestInformation: IInsuranceDetails;

  isDisableRejectReason: boolean = false;
  requestStatus: string = '';
  MSuffix: string = "";
  isVisableRejectreason: boolean = false;
  isVisableRejectedBy: boolean = false;
  isDisableDemographicsbutton: boolean = false;
  //rejectedBy: string = '';
  //rejectedDate: string = '';

  maxChars = 230;
  charCount = '';
  isPatientStatus: boolean = false;
  patientId: number = 0;
  hideRejectbutton: boolean = true;
  hideRejectReason: boolean = true;
  rejectNotes: string = '';
  dpatId: string;
  getPatientRequestDetails(id: number) {
    ;
    this.personalService.getPatientPortalPersonalDetails(id)
      .subscribe(
        (personal: any) => {
          if (personal != null && personal != undefined) {
            if (personal.PreferredContactMethod == 0) {
              personal.PreferredContactMethod = "";
            }
            this.dpatId = personal.DpatId;
            this.patientId = personal.PatientId;
            this.MPatientLastName = personal.LastName;
            this.MPatientMiddleName = personal.MiddleName;
            this.MPatientFirstName = personal.FirstName;
            // this.MDob = personal.Dob;
            this.MDob = personal.Dob === null ? "" : new DatePipe('en-US').transform(personal.Dob, 'MM/dd/yyyy');
            this.MGender = personal.GenderName;
            // this.MMaritalStatus = personal.MaritalStatus;
            // this.MEthnicity = personal.EthniCity;
            this.MSSN = personal.SSN;
            // this.MMaidenName = personal.MiddleName;
            // this.MLocations = personal.LocationName;
            this.MContactAddressLine1 = personal.AddressLine1;
            this.MContactAddressLine2 = personal.AddressLine2;
            this.MContactZipCode = personal.ZIP;
            this.MContactZipCodeExt = personal.Extension
            this.MContactCity = personal.City;
            this.MContactState = personal.State;
            this.MContactHomePhone = personal.HomePhone;
            this.MContactCellPhone = personal.CellPhone;
            this.MContactWorkPhone = personal.WorkPhone;
            this.MPreferredContactMethod = personal.PreferredContactMethod
            this.MPrimaryEmail = personal.PrimaryEmail;
            this.MSecondaryEmail = personal.SecondaryEmail;
            this.MNotes = personal.comments;
            this.requestStatus = personal.status;
            this.MSuffix = personal.Suffix;
            this.rejectedBy = personal.createdBy;
            // this.rejectedDate =  personal.rejectedOn === null ? "" : new DatePipe('en-US').transform(personal.rejectedOn, 'MM/dd/yyyy');
            this.rejectedDate = personal.rejectedOn;
          }
          // if(this.patientId != null)
          // {
          //   this.getPeresonalInfo(this.patientId);
          // }

          if (this.requestStatus === 'Completed') {
            this.hideRejectbutton = false;
            this.hideRejectReason = false;
            this.isPatientStatus = true;
            this.patientId = Number(this.patientId);
            this.PatientDemographicsForm.patchValue({
              rejectReason: false
            })
          } else {
            this.hideRejectbutton = true;
            this.hideRejectReason = true;
          }
          if (this.MNotes == null || this.MNotes == "") {
            this.isDisableRejectReason = false;
          } else {
            this.hideRejectbutton = false;
            this.hideRejectReason = true;
            this.PatientDemographicsForm.patchValue({
              rejectNotes: this.MNotes,
              rejectReason: true
            })
            this.rejectNotes = this.MNotes;
            this.isVisableRejectedBy = true;
            this.charCount = this.MNotes;
            this.rejectedBy = this.rejectedBy + ' ' + this.rejectedDate;
            this.rejectedDate = this.rejectedDate;
            this.isVisableRejectreason = true;
            this.isDisableRejectReason = true;
            this.isDisableDemographicsbutton = true;
          }
        },
        (err: any) => {
          console.log(err);
        });
  }
  public lstattrbutes: IAttributes[];
  public lstGender: IAttributes[];
  public lstPreferredContactMethod: IAttributes[];
  public lstcontacttype: IAttributes[];
  public lstEthinicity: IAttributes[];
  public lstMaritalStatus: IAttributes[];
  public lstRace: IAttributes[];
  public lstLanguage: IAttributes[];
  public lstLocations: ILocationDetails[];
  public lstrelations: IAttributes[];

  personalDropDownsBinding() {
    ;

    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.lstGender = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '11');
      this.lstMaritalStatus = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '13');
      this.lstRace = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '16');
      this.lstEthinicity = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '24');
      this.lstPreferredContactMethod = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '58');
      this.lstLanguage = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '26');
      this.lstcontacttype = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '9');
      this.lstrelations = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '19');
    });
  }
  onClick_navigateToDemographics() {
    CommonComponents.patientId = this.patientId,//this.lstInsRequestUpdate.patientId;
      sessionStorage.setItem("patientId", this.patientId.toString());
    sessionStorage.removeItem("AlertsheaderIconVisibility");
    sessionStorage.setItem("displayappDate", null);
    sessionStorage.setItem("displayappDate1", null);
    this.router.navigate(['/Demographics/Personal', this.linkID, 'PPortal']);
  }

  onClick_backToMessages() {
    // this.router.navigate(['messageInbox']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }


  rejectRequestInfo: MessageInbox;
  // onClick_ReasonForReject() {
  //   this.rejectRequestInfo = this.PatientDemographicsForm.value;
  //   this.rejectRequestInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
  //   this.rejectRequestInfo.comments = this.PatientDemographicsForm.value.rejectNotes;
  //   this.rejectRequestInfo.linkId = this.linkID.toString();
  //   this.rejectRequestInfo.status = 'Rejected';
  //   this.rejectRequestInfo.requestType = 'Rejected';
  //   if (this.PatientDemographicsForm.value.rejectNotes != '') {
  //     this.personalService.updatePatientRequestInformationByLinkId(this.rejectRequestInfo)
  //       .subscribe(
  //         (result: any) => {
  //           this.toastr.success(result)
  //           this.getPatientRequestDetails(this.linkID);
  //         },
  //         (err: any) => {
  //           console.log(err);
  //         });
  //   }


  // }

  onClick_ReasonForReject() {
    ;
    if (this.linkID != undefined || this.linkID != null) {
      var commenttext = this.PatientDemographicsForm.value.rejectNotes;
      if (commenttext == "") {
        this.toastr.warning("Please enter the comments");
        return false;
      }
      this.sharedService.OnCancelBooking(this.linkID, 'Rejected', commenttext).subscribe(
        (data: any) => {
          this.toastr.success(data);
          //this.getBookingDetails();
          //this.router.navigate(['messageInbox']);
          this.router.navigate(['tasksandmessages/', 'BackToMessages']);
        },
        (err: any) => {
          console.log(err);
        });
    }
  }

  keyupRejectReason(event: any) {

  }
  changeReasonforReject(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = true;
      this.isDisableDemographicsbutton = true;

    }
    else {
      this.PatientDemographicsForm.patchValue({
        rejectNotes: ''
      })
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
    }
  }

  personalInfo: IPersonalInfo;
  getPeresonalInfo(id: number) {
    ;
    this.personalService.getPPersonalInfo(id)
      .subscribe(
        (personal: IPersonalInfo) => {
          ;
          this.personalInfo = personal;
          this.editPersonalInfo(personal);

        },
        (err: any) => console.log(err)
      );
  }
  editPersonalInfo(personal: IPersonalInfo) {
    ;

    this.PatientLastName = personal.lastName;
    this.PatientMiddleName = personal.middleName;
    this.PatientFirstName = personal.firstName;
    //this.Dob = personal.dob;
    this.Dob = personal.dob === null ? "" : new DatePipe('en-US').transform(personal.dob, 'MM/dd/yyyy');

    this.Gender = personal.gender;
    this.SSN = personal.ssn;
    this.Suffix = personal.suffix;
    // this.Ethnicity = personal.ethniCity;
    // this.Language = personal.languages;
    // this.MaidenName = personal.middleName;
    // this.Locations = personal.locationName;
    this.ContactAddressLine1 = personal.currentAddressDetails.address1;
    this.ContactAddressLine2 = personal.currentAddressDetails.address2;
    this.ContactZipCode = personal.currentAddressDetails.postalCode;
    this.ContactZipCodeExt = personal.currentAddressDetails.postalExCode
    this.ContactCity = personal.currentAddressDetails.city;
    this.ContactState = personal.currentAddressDetails.state;
    this.ContactHomePhone = personal.currentAddressDetails.homePhone;
    this.ContactCellPhone = personal.currentAddressDetails.cellPhone;
    this.ContactWorkPhone = personal.currentAddressDetails.workPhone;
    this.PreferredContactMethod = personal.preferredContactMethod
    this.PrimaryEmail = personal.currentAddressDetails.emailId;
    this.SecondaryEmail = personal.secondaryEmail;
    //  this.Notes = personal.notes;
    sessionStorage.setItem("patientId", this.patientId.toString());
  }
}

